import { DbMongoSerializationBaseInfos } from "./db-mongo-serialization-base-infos";

import { CurrencyPriceInfos } from "./currency-price-infos";
import { OrderManualTaskTasksPriceRule } from "./order-manual-task-tasks-price-rule";
import { immerable } from "immer";
import { CurrencyTypes } from "./currency-types";

export class DbOrderManualTaskTasksInfos extends DbMongoSerializationBaseInfos {
  [immerable] = true;
  canBeDisabled: boolean | null = null;
  isDisabled: boolean | null = null;
  platformId: number | null = 0;
  createdByUserId: number | null = 0;
  serviceId: number | null = 0;
  createdDate: Date | null = null;
  name: string | null = null;
  description: string | null = null;
  erpTaskCode: string | null = null;
  comment: string | null = null;
  prices: CurrencyPriceInfos[] | null = [
    { price: 0, currency: CurrencyTypes.EUR, priceDetails: null, [immerable]: true },
    { price: 0, currency: CurrencyTypes.USD, priceDetails: null, [immerable]: true },
  ];
  priceRules: OrderManualTaskTasksPriceRule[] | null = null;
  createdByUserName: string | null = null;
  serviceName?: string | null = null;

  constructor(init?: Partial<DbOrderManualTaskTasksInfos>) {
    super();
    Object.assign(this, init);
  }
}
